// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"27f8fdb8","286":"acfe2a0a","349":"99b09033","500":"05272e2f","507":"08864434","739":"00b74268","754":"39af2d68","803":"1c5fa51a","853":"58f9bc07"}[chunkId] + ".chunk.js";
};